import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import nodeinstance from "../../nodeInstance";

const getGrAjeerData = createAsyncThunk("api/ajeer?type=2", async (token) => {
    try {
        const response = await nodeinstance.get("/ajeer?type=2", {
            headers: { Authorization: `Bearer ${token}` },
        });
        return response.data;
    } catch (e) {
        throw new Error(e.message);
    }
});


const GrAjeerDataSlice = createSlice({
    name: "absher",
    initialState: {
        data: null,
        error: "",
        status: false,
        isLoading: false,
    },
    reducers: {},
    extraReducers: (builder) => {
        builder
            .addCase(getGrAjeerData.fulfilled, (state, action) => {
                state.data = action.payload;
                state.isLoading = false;
                state.status = true;
            })
            .addCase(getGrAjeerData.pending, (state, action) => {
                state.isLoading = true;
            })
            .addCase(getGrAjeerData.rejected, (state, action) => {
                state.isLoading = false;
                state.error = action.error.message;
            });
    },
});

export { getGrAjeerData };
export default GrAjeerDataSlice.reducer;
